import WebApi from '@/views/loyalty/shared/modules/web_api'
import { unwrapEnvelope, envelopeError, buildQuery } from '@/views/skud/shared/modules/skud-http'

// Мутации Charon: успех {error:false,data} -> {ok:true,data}, иначе {ok:false,error}.
function mutationResult (res) {
  const data = unwrapEnvelope(res)
  if (data) return { ok: true, data: data }
  return { ok: false, error: envelopeError(res) || 'Ошибка запроса' }
}

export class SkudVisitEndpoint {
  constructor () {
    this.url = `${process.env.VUE_APP_CHARON_URL}api/management/`
    this.webApi = new WebApi()
  }

  // POST /places/{placeId}/visits — создание заявки (идемпотентно по request_id).
  async createVisit (placeId, body) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/visits', body)
    return mutationResult(res)
  }

  // POST /places/{placeId}/visits/{visitId}/submit — Draft -> Pending.
  async submitVisit (placeId, visitId, comment) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/visits/' + visitId + '/submit', { comment: comment || null })
    return mutationResult(res)
  }

  // POST /places/{placeId}/visits/{visitId}/confirm — только сужение точек/окна.
  // body: {visit_id, narrowed_point_ids?, narrowed_starts_at?, narrowed_ends_at?}
  async confirmVisit (placeId, visitId, body) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/visits/' + visitId + '/confirm', body)
    return mutationResult(res)
  }

  // POST /places/{placeId}/visits/{visitId}/reject — reason 5..500, обязателен.
  async rejectVisit (placeId, visitId, reason) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/visits/' + visitId + '/reject', { reason: reason })
    return mutationResult(res)
  }

  // POST /places/{placeId}/visits/{visitId}/cancel — reason необязателен.
  async cancelVisit (placeId, visitId, reason) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/visits/' + visitId + '/cancel', { reason: reason || null })
    return mutationResult(res)
  }

  // GET /visits (client-scope, placeId не задан) или /places/{placeId}/visits — keyset.
  // params: {state, limit, cursor_visit_id}.
  // -> {items, next_cursor_visit_id} или null.
  async getVisits (placeId, params) {
    const seg = placeId ? 'places/' + placeId + '/' : ''
    const res = await this.webApi.get(this.url + seg + 'visits?' + buildQuery(params || {}))
    this.lastError = res
    return unwrapEnvelope(res)
  }

  // GET /places/{placeId}/visits/{visitId} -> объект визита или null.
  async getVisit (placeId, visitId) {
    const res = await this.webApi.get(this.url + 'places/' + placeId + '/visits/' + visitId)
    this.lastError = res
    return unwrapEnvelope(res)
  }
}
